// src/modules/productos/composables/categoriaComposables/useCategoriaProductoCreate.ts

import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { CategoriaCreateInterface } from "../../interfaces/categoriaInterfaces/CategoriaCreate.interface";
import { ApiResponse } from "@/utils/ApiResponse";
import { CategoriasProductoInterface } from "../../interfaces/categoriaInterfaces/CategoriasProducto.interface";
import { useToast } from "vue-toastification";
import { CategoriaProductoCreateAction } from "../../actions/categoriaActions";

const toast = useToast();

export function useCategoriaProductoCreate(onClose?: () => void) {
  const queryClient = useQueryClient();

  // Mutation para crear la categorÃ­a
  const mutation = useMutation({
    mutationFn: (categoria: CategoriaCreateInterface) =>
      CategoriaProductoCreateAction(categoria),

    onSuccess: async (response: ApiResponse<CategoriasProductoInterface>) => {
      await queryClient.invalidateQueries({
        queryKey: ["CategoriaProductosList"],
      });

      toast.success("Categoría creada correctamente");
      if (onClose) onClose();
    },

    onError: () => {
      toast.error("No se pudo crear la categoría. Intenta de nuevo.");
      if (onClose) onClose();
    },
  });

  return {
    ...mutation, // => { mutate, mutateAsync, isPending, isError, error, isSuccess, data }
  };
}
